<!-- CheckoutNow.vue -->
 
<template>
  <div class="checkout-view">
    <div class="header">
      <h1>Checkout</h1>
    </div>

    <!-- User Information Display -->
    <!-- <div class="user-info-section" v-if="currentUser.userName">
      <h2>Delivery Information</h2>
      <div class="user-details">
        <div class="user-detail-item">
          <span class="label">Name:</span>
          <span class="value">{{ currentUser.userName }}</span>
        </div>
        <div class="user-detail-item">
          <span class="label">Mobile:</span>
          <span class="value">{{ currentUser.userMobile }}</span>
        </div>
        <div class="user-detail-item">
          <span class="label">Address:</span>
          <span class="value">{{ currentUser.userAddress || 'Address not provided' }}</span>
        </div>
        <div class="user-detail-item" v-if="currentUser.userEmail">
          <span class="label">Email:</span>
          <span class="value">{{ currentUser.userEmail }}</span>
        </div>
      </div>
    </div> -->

    <!-- Order Summary -->
    <div class="order-summary">
      <h2>Order Summary</h2>

      <!-- Items in cart -->
      <div class="cart-items">
        <div v-for="item in localCartItems" :key="item.medicine.id" class="cart-item">
          <div class="item-details">
            <div class="item-info">
              <h4>{{ item.medicine.name }}</h4>
              <span class="category">{{ item.medicine.generic }} {{ item.medicine.strength }}</span>
              <span class="medicine_quantity_details">1 {{ item.medicine.pack_type }} : {{ item.medicine.pack_amount }} {{ item.medicine.formation }}</span>
            </div>
            <div class="item-price">
              <span class="price">${{ parseFloat(item.medicine.price || 0).toFixed(2) }}</span>
              <div class="quantity-selector">
                <button @click="decreaseQuantity(item.medicine)">-</button>
                <span>{{ item.quantity }}</span>
                <button @click="increaseQuantity(item.medicine)">+</button>
              </div>
              <span class="item-total">${{ (parseFloat(item.medicine.price || 0) * item.quantity).toFixed(2) }}</span>
            </div>
            <div>
              <button class="remove-button" @click="removeItem(item.medicine)" aria-label="Remove item">
                <img src="/image/delete_icon.png" alt="Delete" width="15" height="15">
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Order totals -->
      <div class="order-totals">
        <div class="total">
          <span>Subtotal</span>
          <span>${{ total.toFixed(2) }}</span>
        </div>
      </div>
    </div>

    <div class="sections-container">
      <!-- Delivery Information -->
      <div class="delivery-info">
        <h2>Additional Information</h2>
        <div class="form-group">
          <label>Mobile Number</label>
          <input type="tel" v-model="mobileNumber" placeholder="Enter your mobile number"/>
        </div>
        <div class="form-group">
          <label>Shipping Address</label>
          <textarea 
            v-model="deliveryAddress" 
            placeholder="Enter your shipping address"
            rows="2"
          ></textarea>
        </div>
        <!-- <div class="form-group">
          <label>Preferred Delivery Date</label>
          <input 
            type="date" 
            v-model="deliveryDate" 
            :min="minDeliveryDate"
          />
        </div> -->
        <div class="form-group">
          <label>Note</label>
          <textarea 
            v-model="orderNotes" 
            placeholder="Enter any notes or instructions"
            rows="2"
          ></textarea>
        </div>
      </div>

      <!-- Payment Method -->
      <div class="payment-method">
        <h2>Payment Method</h2>
        <div class="payment-options">
          <div 
            class="payment-option" 
            :class="{ active: paymentMethod === 'cash' }"
            @click="paymentMethod = 'cash'"
          >
            <div class="payment-icon">💵</div>
            <span>Cash on Delivery</span>
          </div>
          <div 
            class="payment-option" 
            :class="{ active: paymentMethod === 'mobile' }"
            @click="paymentMethod = 'mobile'"
          >
            <div class="payment-icon">
              <img class="payment-icon" src="/image/BKash-Icon-Logo.svg" alt="Bkash">
            </div>
            <span>Bkash</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Place Order Button -->
    <div class="place-order">
      <button class="place-order-button" @click="placeOrder" :disabled="isSubmitting">
        {{ isSubmitting ? 'Processing...' : 'Place Order' }}
      </button>
    </div>

    <!-- Order Success Modal -->
    <div class="modal" v-if="showOrderSuccess">
      <div class="modal-content">
        <div class="success-icon">✅</div>
        <h2>Order Placed Successfully!</h2>
        <p class="order-id">Order ID: {{ orderId }}</p>
        <button class="close-button" @click="closeModal">Your orders</button>
      </div>
    </div>

    <!-- Error Modal -->
    <div class="modal" v-if="showErrorModal">
      <div class="modal-content error">
        <div class="error-icon">❌</div>
        <h2>Order Placement Failed</h2>
        <p>{{ errorMessage }}</p>
        <button class="close-button" @click="closeErrorModal">Try Again</button>
      </div>
    </div>
  </div>
</template>

<script>
// CheckoutNow.vue - Merged with user information features
export default {
  name: 'CheckoutNow',
  props: {
    cartItems: {
      type: Array,
      default: () => []
    },
    pharmacy: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localCartItems: [],
      localPharmacy: {},
      
      currentUser: {
        userId: '',
        userName: '',
        userMobile: '',
        userAddress: '',
        userEmail: ''
      },
      deliveryDate: new Date().toISOString().substr(0, 10),
      deliveryTime: 'morning',
      deliveryAddress: '',
      mobileNumber: '',
      orderNotes: '',
      paymentMethod: 'cash', // Default to cash
      deliveryFee: 0,
      taxRate: 0,
      showOrderSuccess: false,
      showErrorModal: false,
      errorMessage: '',
      orderId: '',
      isSubmitting: false,
      apiBaseUrl: 'https://e01.yeapps.com/medi360/orders'
    }
  },
  computed: {
    subtotal() {
      return this.localCartItems.reduce((total, item) => 
        total + (parseFloat(item.medicine.price || 0) * item.quantity), 0)
    },
    tax() {
      return this.subtotal * this.taxRate
    },
    total() {
      return this.subtotal + this.deliveryFee + this.tax
    },
    formattedDeliveryDate() {
      const date = new Date(this.deliveryDate)
      return date.toLocaleDateString('en-US', { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      })
    },
    minDeliveryDate() {
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      return tomorrow.toISOString().split('T')[0]
    }
  },
  methods: {
    // Load user data from localStorage
    loadUserData() {
      this.currentUser = {
        userId: localStorage.getItem('userId') || '',
        userName: localStorage.getItem('userName') || '',
        userMobile: localStorage.getItem('userMobile') || '',
        userAddress: localStorage.getItem('userAddress') || '',
        userEmail: localStorage.getItem('userEmail') || ''
      }
      
      // Pre-fill form fields with user data
      if (this.currentUser.userMobile) {
        this.mobileNumber = this.currentUser.userMobile
      }
      if (this.currentUser.userAddress) {
        this.deliveryAddress = this.currentUser.userAddress
      }
      
      console.log('Current user data loaded in CheckoutNow:', this.currentUser)
    },

    // Check if user is logged in
    checkAuthStatus() {
      const isLoggedIn = localStorage.getItem('isLoggedIn')
      if (isLoggedIn !== 'true' || !this.currentUser.userId) {
        console.log('User not logged in, redirecting to login')
        this.$router.push('/login')
        return false
      }
      return true
    },

    goBack() {
      this.$emit('back')
      this.$router.go(-1)
    },
    increaseQuantity(medicine) {
      const item = this.localCartItems.find(item => item.medicine.id === medicine.id)
      if (item) {
        item.quantity++
        this.$emit('update:cartItems', [...this.localCartItems])
        this.updateSessionStorage()
      }
    },
    decreaseQuantity(medicine) {
      const item = this.localCartItems.find(item => item.medicine.id === medicine.id)
      if (item && item.quantity > 1) {
        item.quantity--
        this.$emit('update:cartItems', [...this.localCartItems])
        this.updateSessionStorage()
      } else if (item && item.quantity === 1) {
        // Remove item if quantity becomes 0
        this.removeItem(medicine)
      }
    },
    removeItem(medicine) {
      const index = this.localCartItems.findIndex(item => item.medicine.id === medicine.id)
      alert('Your item will be deleted.')
      if (index !== -1) {
        this.localCartItems.splice(index, 1)
        this.$emit('update:cartItems', [...this.localCartItems])
        this.updateSessionStorage()
        
        // If cart becomes empty, go back to medicine list
        if (this.localCartItems.length === 0) {
          setTimeout(() => {
            alert('Your cart is now empty.')
            this.$router.push('/pharmacies')
          }, 300)
        }
      }
    },
    updateSessionStorage() {
      // Update cart items in session storage
      sessionStorage.setItem('cartItems', JSON.stringify(this.localCartItems))
    },

    // Generate unique order ID
    generateOrderId() {
      const timestamp = Date.now()
      return `ORD-${timestamp}`
    },

    // Validate order data before submission
    validateOrder() {
      if (!this.currentUser.userId) {
        alert('User information is missing. Please log in again.')
        return false
      }

      if (!this.deliveryAddress) {
        alert('Please enter a delivery address')
        return false
      }

      if (!this.mobileNumber) {
        alert('Please enter a mobile number')
        return false
      }

      if (!this.paymentMethod) {
        alert('Please select a payment method')
        return false
      }

      if (this.localCartItems.length === 0) {
        alert('Your cart is empty. Please add items before checkout.')
        return false
      }

      if (!this.localPharmacy.id) {
        alert('Pharmacy information is missing. Please go back and select a pharmacy.')
        return false
      }

      return true
    },
    
    // Function to place the order
    async placeOrder() {
      // Validate form fields
      if (!this.validateOrder()) {
        return
      }

      try {
        this.isSubmitting = true;
        // Generate a random order ID
        this.orderId = this.generateOrderId();
        
        // Process order items to include all necessary details for order_details table
        const orderItems = this.localCartItems.map(item => ({
          medicineId: item.medicine.id,
          medicineName: item.medicine.name || '',
          medicineGeneric: item.medicine.generic || '',
          medicineCompany: item.medicine.company || '',
          medicineCategory: item.medicine.generic || '',
          quantity: item.quantity,
          available_qty: item.quantity,
          price: parseFloat(item.medicine.price || 0),
          totalPrice: parseFloat(item.medicine.price || 0) * item.quantity,
          strength: item.medicine.strength,
          formation: item.medicine.formation,
          pack_type: item.medicine.pack_type,
          pack_amount: item.medicine.pack_amount
        }));
        
        // Prepare order data with user information
        const orderData = {
          id: this.orderId,
          userId: this.currentUser.userId,
          userName: this.currentUser.userName,
          userMobile: this.mobileNumber,
          userAddress: this.deliveryAddress,
          userEmail: this.currentUser.userEmail || '',
          customerId: this.localPharmacy.id || '',
          customerName: this.localPharmacy.name || '',
          customerAddress: this.localPharmacy.address || '',
          paymentMethod: this.paymentMethod,
          orderNotes: this.orderNotes,
          orderStatus: 'pending',
          orderDate: new Date().toISOString(),
          orderTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
          deliveryDate: this.deliveryDate,
          deliveryFee: this.deliveryFee,
          subtotal: this.subtotal,
          tax: this.tax,
          totalAmount: this.total,
          orderItems: orderItems
        }
        console.log('Sending order data:', orderData);

        // Send order data to backend
        const response = await fetch(this.apiBaseUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(orderData)
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || `Server responded with status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Order placed successfully:', data);
        
        // Show success modal
        this.showOrderSuccess = true;
        this.orderId = data.order_id || this.orderId;
        
        // Clear session storage after successful order
        sessionStorage.removeItem('cartItems');
        sessionStorage.removeItem('pharmacy');

      } catch (error) {
        console.error('Error placing order:', error);
        this.errorMessage = error.message || 'Failed to place your order. Please try again later.';
        this.showErrorModal = true;
      } finally {
        this.isSubmitting = false;
      }
    },
    closeModal() {
      this.showOrderSuccess = false;
      // Navigate back to pharmacy list
      this.$router.push('/user_order_history');
    },
    closeErrorModal() {
      this.showErrorModal = false;
    },
    loadDataFromSessionStorage() {
      // Try to get cart items from session storage
      const storedCartItems = sessionStorage.getItem('cartItems')
      const storedPharmacy = sessionStorage.getItem('pharmacy')
      
      if (storedCartItems) {
        try {
          const parsedItems = JSON.parse(storedCartItems);
          
          // Ensure each medicine has a price property
          this.localCartItems = parsedItems.map(item => {
            if (!item.medicine.price && item.medicine.tp_amount) {
              item.medicine.price = parseFloat(item.medicine.tp_amount);
            } else if (!item.medicine.price) {
              item.medicine.price = 0;
            }
            return item;
          });
          
          console.log('Loaded cart items from session storage:', this.localCartItems.length)
        } catch (error) {
          console.error('Error parsing cart items from session storage:', error)
          this.localCartItems = [];
        }
      }
      
      if (storedPharmacy) {
        try {
          // Parse pharmacy data from session storage
          this.localPharmacy = JSON.parse(storedPharmacy)
          console.log('Loaded pharmacy from session storage:', this.localPharmacy)
        } catch (error) {
          console.error('Error parsing pharmacy from session storage:', error)
          this.localPharmacy = {};
        }
      }

      // Load user data from session (fallback if localStorage fails)
      const storedUser = sessionStorage.getItem('currentUser')
      if (storedUser && !this.currentUser.userId) {
        try {
          const sessionUser = JSON.parse(storedUser)
          this.currentUser = { ...this.currentUser, ...sessionUser }
          console.log('Loaded user data from session:', this.currentUser)
        } catch (error) {
          console.error('Error parsing user data from session storage:', error)
        }
      }
    }
  },
  created() {
    // Load user data first and check authentication
    this.loadUserData()
    if (!this.checkAuthStatus()) {
      return // Exit if not authenticated
    }

    // Initialize local copies of props
    this.localCartItems = [...this.cartItems].map(item => {
      // Ensure price property exists
      if (!item.medicine.price && item.medicine.tp_amount) {
        item.medicine.price = parseFloat(item.medicine.tp_amount);
      } else if (!item.medicine.price) {
        item.medicine.price = 0;
      }
      return item;
    });
    
    // Initialize pharmacy data from props
    this.localPharmacy = {...this.pharmacy};
    
    // Load data from session storage (this will override prop data if available)
    this.loadDataFromSessionStorage();
    
    // Set default delivery date to tomorrow
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    this.deliveryDate = tomorrow.toISOString().split('T')[0]
    
    // If still no cart items are available, redirect back
    if (!this.localCartItems || this.localCartItems.length === 0) {
      console.warn('No cart items found, returning to pharmacy list');
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.user-info-section {
  background-color: #111;
  border-radius: 8px;
  padding: 12px;
  margin: 0 12px 16px 12px;
  border-bottom: 1px solid #333;
}

.user-info-section h2 {
  font-size: 14px;
  margin: 0 0 12px 0;
  padding: 0;
  color: #3aa757;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.user-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.user-detail-item .label {
  font-size: 14px;
  color: #ccc;
  font-weight: 500;
  min-width: 60px;
}

.user-detail-item .value {
  font-size: 14px;
  color: #e2e2e2;
  text-align: right;
  flex: 1;
  margin-left: 12px;
}

.remove-button {
  background-color: #ff4d4f;
  color: #e2e2e2;
  border: none;
  border-radius: 6px;
  padding: 4px 4px;
  margin: 26px 0 0 0px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.25s ease, transform 0.15s ease;
}

.remove-button:hover {
  background-color: #ff7875;
  transform: scale(1.05);
}

.remove-button img {
  width: 12px;
  height: 12px;
  object-fit: contain;
}

.item-price {
  display: flex;
  padding: 0 20px 0 0;
  align-items: center;
  flex-wrap: wrap;
}

.item-total {
  margin: 0 0;
}
.checkout-view {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background-color: #000;
  color: #e2e2e2;
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  position: relative;
  padding-bottom: 70px; /* Reduced space for the place order button */
}

.header {
  display: flex;
  color: #3aa757;
  align-items: center;
  padding: 12px 16px; /* Reduced padding */
  position: sticky;
  top: 0;
  background-color: #000;
  border-radius: 8px;
  z-index: 10;
  border-bottom: 1px solid #333;
}

.header h1 {
  margin: 0;
  font-size: 18px; /* Smaller font */
  flex: 1;
}

h2 {
  font-size: 14px; /* Smaller heading */
  margin: 12px 0 8px; /* Reduced margins */
  padding: 0 16px;
}

.order-summary, .delivery-info, .payment-method {
  margin-bottom: 16px; 
  border-bottom: 1px solid #333;
  padding-bottom: 12px; 
}

.delivery-info h2, .payment-method h2 {
  margin-bottom: 8px; 
  font-size: 14px; 
}
.cart-items {
  padding: 12px 12px;
}

.cart-item {
  padding: 8px 0; 
  border-bottom: 1px solid #222;
}

.item-details {
  display: flex;
  justify-content: space-between;
}

.item-info {
  flex: 3;
  display: flex;
  flex-direction: column;
}

.item-info h4 {
  margin: 0 0 2px 0; /* Reduced margin */
  font-size: 14px;
}

.item-price {
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.category {
  color: #ccc;
  font-size: 11px; /* Smaller font */
  margin-bottom: 2px;
}

.price {
  font-weight: bold;
  color: #3aa757;
  font-size: 14px;
  margin-bottom: 4px;
}

.quantity-selector {
  display: flex;
  align-items: center;
  margin: 2px 0;
}

.quantity-selector button {
  width: 22px;
  height: 22px;
  background-color: #333;
  color: #e2e2e2;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-selector span {
  padding: 0 8px;
  font-size: 14px;
}

.item-total {
  font-weight: bold;
  color: #3aa757;
  font-size: 14px;
}

.order-totals {
  padding: 12px;
  background-color: #111;
  border-radius: 4px;
  margin: 12px;
}

.totals-row {
  display: flex;
  justify-content: space-between;
}

.totals-label, .totals-amount {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
}

.totals-amount {
  text-align: right;
}

.total {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #333;
  font-weight: bold;
  font-size: 14px;
}

.total span:last-child {
  color: #3aa757;
  margin-right: 30px;
}

.sections-container {
  padding: 0 12px;
}

.delivery-info, .payment-method {
  background-color: #111;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}

.form-group {
  margin-bottom: 12px;
}

label {
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  color: #ccc;
}

input, textarea {
  width: 100%;
  padding: 8px 10px;
  border-radius: 4px;
  border: none;
  background-color: #222;
  color: #e2e2e2;
  box-sizing: border-box;
  font-size: 14px;
}

.payment-options {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.payment-option {
  flex: 1;
  background-color: #222;
  border-radius: 6px;
  padding: 8px 6px;
  text-align: center;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.payment-option.active {
  border-color: #3aa757;
  background-color: #111;
}

.payment-icon {
  font-size: 20px;
  height: 25px;
  width: 25px;
  margin-bottom: 4px;
}

.payment-option span {
  font-size: 11px;
}

.place-order {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #111;
  padding: 12px 16px;
  max-width: 480px;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.3);
}

.place-order-button {
  width: 100%;
  background-color: #3aa757;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal-content {
  background-color: #111;
  border-radius: 8px;
  padding: 20px;
  width: 80%;
  max-width: 320px;
  text-align: center;
}

.success-icon {
  font-size: 20px;
  margin-bottom: 12px;
}

.modal-content h2 {
  margin: 8px 0;
  padding: 0;
}

.modal-content p {
  margin-bottom: 12px;
  color: #ccc;
  font-size: 14px;
}

.order-id {
  font-family: monospace;
  background-color: #222;
  padding: 6px;
  border-radius: 4px;
  margin: 12px 0;
  font-size: 14px;
}

.close-button {
  background-color: #3aa757;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 12px;
}

.medicine_quantity_details {
  font-size: 11px;
  color: #ccc;
  margin-top: 2px;
}

/* Add a bit of responsiveness for very small screens */
@media (max-width: 340px) {
  .item-details {
    flex-direction: column;
  }
  
  .item-price {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
  }
  
  .price, .item-total {
    margin: 0;
  }

  .user-detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }
  
  .user-detail-item .value {
    text-align: left;
    margin-left: 0;
  }
}
</style>